import type { PolicyTransactionHistoryViewModel } from 'src/api/types/PolicyTransactionHistoryViewModel';

import { Box } from '@mui/material';

import { TransactionHistoryDetailCard } from './transaction-history-detail-card';

type Props = {
  row: PolicyTransactionHistoryViewModel;
  index: number;
};

export function TransactionHistoryDetail({ row, index }: Readonly<Props>) {
  if (!row.details || row.details.length === 0) {
    return null; // No detail sections to render
  }

  const detail = row.details[0];

  if (
    detail.detailType !== 'Cancellation'
    && detail.detailType !== 'Reinstatement'
    && detail.detailType !== 'Compliance'
    && detail.detailType !== 'Noncompliance'
  ) {
    return null;
  }

  return (
    <Box sx={{ px: 0, py: 0, display: 'grid', gap: 1 }} data-testid={`transaction-history-detail-${index}`}>
      <TransactionHistoryDetailCard detailType={detail.detailType} details={[detail]} rowIndex={index} />
    </Box>
  );
}
